// @flow

export const isCordovaApp = () => !!window.cordova;
